import { PermissionEntity, RawPermission } from './Types';
import { UserEntity } from '../User/Types';
import { UserModel } from '../User/UserModel';
import { BaseModel } from '../BaseModel/BaseModel';

export class PermissionModel
    extends BaseModel<RawPermission, PermissionEntity>
    implements PermissionEntity
{
    architectProjectId: number | null = null;
    billOfMaterialsProjectId: number | null = null;
    createdAt: string = new Date().toISOString();
    id: number = 0;
    level: number[] = [];
    projectId: number = 0;
    updatedAt: string = new Date().toISOString();
    user?: UserEntity;
    userId: number = 0;

    constructor(permission?: RawPermission) {
        super();
        if (permission) {
            this.initialize(permission);
        }
    }

    initialize(permission: RawPermission) {
        this.architectProjectId = permission.project_id;
        this.billOfMaterialsProjectId = permission.project_id;
        this.createdAt = permission.created_at;
        this.id = permission.id;
        this.level = permission.level;
        this.projectId = permission.project_id;
        this.updatedAt = permission.updated_at;
        this.user = permission.user ? new UserModel(permission.user) : undefined;
        this.userId = permission.user_id;
    }

    parse(): RawPermission {
        return {
            architect_project_id: this.architectProjectId,
            bill_of_materials_project_id: this.billOfMaterialsProjectId,
            created_at: this.createdAt,
            id: this.id,
            level: this.level,
            project_id: this.projectId,
            updated_at: this.updatedAt,
            user_id: this.userId,
            ...(this.user && { user: this.user.parse() }),
        };
    }
}
